import React, { useCallback, useEffect, useState } from "react";
import {
  GoogleMap,
  useLoadScript,
  MarkerClusterer,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import throttle from "lodash.throttle";

import diamond from "../images/christmas_small.png";
import redDiamond from "../images/christmas_red.png";
import { libraries } from "../helper";
import useGoogleMap from "./useGoogleMap";

let center = {
  lat: 40.689246,
  lng: -111.8964492,
};

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  minimumClusterSize: 5,
  maxZoom: 10,
};

export function Foo() {
  // TODO scope map key
  return (
    <div
      style={{ backgroundColor: "green", width: "100%", height: "100%" }}
    ></div>
  );
}

export default function Map({
  listings,
  setSelectedPlace,
  setShowMap,
  selectedPlace,
  highlightPlace,
  refine,
  onRightClick,
}) {
  // TODO scope map key
  const [mapInstance, setMapInstance] = useGoogleMap();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
    libraries,
    // ...otherOptions
  });
  const [height, setHeight] = useState("100%");
  const [hoverPlaceId, setHoverPlaceId] = useState(null);
  const mapRef = React.useRef(null);

  useEffect(() => {
    //if (typeof window === 'undefined') return;

    const handleResize = () => {
      if (window.innerWidth < 600) {
        setHeight(window.innerHeight - 60);
      } else {
        setHeight("100%");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onLoad = React.useCallback(
    function onLoad(map) {
      let places = new window.google.maps.places.PlacesService(mapRef.current);
      setMapInstance({ map, places });
      // do something with map Instance
    },
    [setMapInstance]
  );
  const onClick = useCallback(
    (marker) => () => {
      setShowMap(false);
      setSelectedPlace(marker);
    },
    [setSelectedPlace, setShowMap]
  );
  const onMouseOver = useCallback(
    (marker) => () => {
      setHoverPlaceId(marker.objectID);
    },
    [setHoverPlaceId]
  );
  const onMouseOut = useCallback(
    (marker) => () => {
      setHoverPlaceId(null);
    },
    [setHoverPlaceId]
  );
  const throttleRefine = React.useMemo(
    () =>
      throttle((request) => {
        refine(request);
      }, 500),
    [refine]
  );

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  if (!isLoaded) {
    return <div>loadin</div>;
  }

  return (
    <>
      <div ref={mapRef} />
      <GoogleMap
        onLoad={onLoad}
        onRightClick={onRightClick}
        mapContainerStyle={{ width: "100%", height: height }}
        onIdle={() => {
          if (!mapInstance || !mapInstance.map) return;
          let bounds = mapInstance.map.getBounds();
          /*
          console.log(
            "bounds",
            bounds.getNorthEast().toJSON(),
            bounds.getSouthWest().toJSON()
          );
          */
          throttleRefine({
            northEast: bounds.getNorthEast().toJSON(),
            southWest: bounds.getSouthWest().toJSON(),
          });
        }}
        zoom={11}
        center={center}
        options={{
          disableDefaultUI: true,
          gestureHandling: "greedy",
          styles: [
            {
              featureType: "poi",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
      >
        <MarkerClusterer options={options}>
          {(clusterer) =>
            listings.map((node) => {
              let place = node;

              return (
                <Marker
                  key={place.objectID}
                  onClick={onClick(place)}
                  onMouseOver={onMouseOver(place)}
                  onFocus={onMouseOver(place)}
                  onMouseOut={onMouseOut(place)}
                  onBlur={onMouseOut(place)}
                  icon={
                    highlightPlace && highlightPlace.objectID === place.objectID
                      ? redDiamond
                      : selectedPlace &&
                        selectedPlace.objectID === place.objectID &&
                        !highlightPlace
                      ? redDiamond
                      : diamond
                  }
                  zIndex={
                    highlightPlace && highlightPlace.objectID === place.objectID
                      ? 100
                      : hoverPlaceId === place.objectID
                      ? 100
                      : undefined
                  }
                  position={place._geoloc}
                  clusterer={clusterer}
                />
              );
            })
          }
        </MarkerClusterer>
      </GoogleMap>
    </>
  );
}
